
<template>

  <v-container fluid>

    <v-row dense no-gutters align="center" justify="start">
        <v-col cols="8">
            <v-text-field 
              v-model="bgname" dense disabled 
              :placeholder="$t('bggroupdialog_label1')"
              outlined height="43"
              color="#808080"
              hide-details
              />
        </v-col>
        <v-col cols="3">
            <v-btn class="search_btn  ml-2 mx-1" elevation="0" outlined large @click="showpopup_com" >{{$t('common_select')}}</v-btn>
        </v-col>
    </v-row>   

    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_com" @keydown.esc="close_com" max-width="600px" >
        <v-card class="dialog_round pa-2">
          
          <v-row justify="space-between">
            <v-col align="start" cols="12" md="6" sm="6" xs="6">
              <span class="ml-10 dialog_title">{{$t('bggroupdialog_label2')}}</span>
            </v-col>
            <v-col align="end" cols="12" md="6" sm="6" xs="6">
              <v-btn class="dialog_close_btn mr-10" outlined rounded fab x-small @click="close_com"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row justify="end">
                <v-col md="2" sm="2" xs="2" class="mr-10">
                  <v-btn class="search_btn" elevation="0" outlined large @click="search_run_com">{{$t("common_search")}}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-data-table
                    :headers="headers_com"
                    :items="itemList_com"
                    v-model="select_com"
                    :no-data-text="$t('common_nodata')"
                    hide-default-footer
                    class="datatablestyle"
                    :items-per-page="pagerow_com"
                    item-key="IDX"
                    >
                    <template v-slot:header.NAME>
                      <label class="cheader_normal" >{{$t("bggroupdialog_col1")}}</label>
                    </template>
                    <template v-slot:header.DESC>
                      <label class="cheader_normal" >{{$t("bggroupdialog_col2")}}</label>
                    </template>
                    <template v-slot:header.BG_NAME>
                      <label class="cheader_normal" >{{$t("bggroupdialog_col3")}}</label>
                    </template>
                    <template v-slot:item.NAME="{ item }">
                      <a @click="save_com(item)">{{item.NAME}}</a>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" class="d-flex justify-center">
                  <v-btn v-if="bottompage_com > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
                  <span v-for="n in subpage_com" :key="n.id">
                      <span v-if="page_com == bottompage_com-1+n">
                          <v-btn color="red" icon small @click="loadpage_com(bottompage_com-1+n)">{{bottompage_com-1+n}}</v-btn>
                      </span>
                      <span v-else>
                          <v-btn icon small @click="loadpage_com(bottompage_com-1+n)">{{bottompage_com-1+n}}</v-btn>
                      </span>
                  </span>
                  <v-btn v-if="subpage_com == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-btn class="dialog_btn mr-5" rounded large @click="clear_com">{{$t('common_selectcancel')}}</v-btn>
              <v-btn color="dialog_cancel_btn" rounded large @click="close_com">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>     
    </v-row>
    
  </v-container>

</template>

<script>
    export default {
        
        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
            bgname: String,
            comidx: Number,
            bgtype: Number,
            cbname:{type:String, default: "dev..."}
        },

        data: ()=> ({
            
            dialog_com : false,
            load_flag : false,
            headers_com: [
                {text: '그룹명',    value: 'NAME', sortable: true, align:'center'},
                {text: '설명',      value: 'DESC', sortable: false, align:'center' },
                {text: '배경',      value: 'BG_NAME', sortable: false, align:'center' }
            ],
            itemList_com: [],
            select_com:[],
            search_keyword_com : '',
            totalcnt_com : 0,      //전체 아이템 개수
            page_com : 0,
            maxpage_com : 0,       //전체 페이지 개수
            startpage_com: 1,      //시작 인덱스
            bottompage_com : 1,    //하단 페이징 번호의 시작점을 계산하기 위한 변수
            subpage_com : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
            pagerow_com : 10,      //한 페이지에 보여줄 row수
            
        }),

        updated(){
          //console.log("event dialog update... " + this.dialog_com);
          if(this.dialog_com){
            if(!this.load_flag && this.itemList_com.length == 0 && this.search_keyword_com.length == 0){
              this.loadpage_com(1);
            }
          }else{
            //팝업이 닫히면
            this.load_flag = false;
          }

        },


        methods: {

            prev_com(){
                this.bottompage_com = this.bottompage_com - 10 >= 1 ? this.bottompage_com - 10 : 1;
                this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
                var temp_page = this.bottompage_com + this.subpage_com - 1; //이전을 누르면 가장 끝 번호 선택
                this.loadpage_com(temp_page);
            },
            next_com(){
                this.bottompage_com = this.bottompage_com + 10 <= this.maxpage_com ? this.bottompage_com + 10 : this.maxpage_com;
                this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
                var temp_page = this.bottompage_com;
                this.loadpage_com(temp_page);
            },

            makepaging_com(){
                var div1 = this.totalcnt_com / this.pagerow_com; 
                var div2 = this.totalcnt_com % this.pagerow_com;
                if(div2 == 0){  
                    this.maxpage_com = parseInt(div1);    
                }else{
                    this.maxpage_com = parseInt(div1+1);
                }
                if(this.bottompage_com == 1){
                this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
                }
            },

            search_run_com(){
                this.loadpage_com(1);
            },

            loadpage_com(p){

                this.page_com = p;
                this.$http.post(this.$host+'/api/BgGroupList',{
                      search_type:''
                    , search_keyword:''
                    , sort_type:''
                    , page: this.page_com
                    , pagerow: this.pagerow_com
                    , COM_IDX: this.comidx
                    , BGTYPE: this.bgtype
                    , ADMIN_IDX: this.$session.get("ADMIN_IDX")
                    , LAN_CODE:this.$i18n.locale
                },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
                .then((result)=>{

                    if(result.data.resultCode == 0){
                        this.load_flag = true;
                        //토큰 저장
                        if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                          this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                        }
                        if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                          this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                        }

                        this.totalcnt_com = result.data.totalcnt;
                        this.makepaging_com();
                        const list = result.data.resultData;
                        this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                        list.forEach(element => {
                            this.itemList_com.push(element); 
                        });

                    }else if(result.data.resultCode == 2){
                      //로그인 필요
                      this.$alert(this.$t("common_tokener"));
                      this.$session.clear("ADMIN_IDX");
                      this.$session.clear("COM_IDX");
                      this.$session.clear("ACNT_IDX");
                      this.$session.clear("GRADE");
                      this.$session.clear("COM_NAME");
                      this.$session.clear("ACCESSTOKEN");
                      this.$session.clear("REFLASHTOKEN");
                      this.$router.push('Login');   //로그인 페이지로 이동

                    }
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                    
                });

            },

            //다이얼로그 닫기
            close_com () {
                this.dialog_com = false
                this.select_com = [];
                this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            },

            //선택취소
            clear_com(){
                this.$emit('cancelcallback', '')
                this.dialog_com = false
                this.select_com = [];
                this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            },

            //추가 저장
            save_com(select_item) {
              this.$emit('callback', select_item);
              //콜백 호출 후 닫아야함.
              this.dialog_com = false
              this.select_com = [];
              this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            },      

            showpopup_com(){
                this.dialog_com = true;
                this.load_flag = false;
            },


        }

    }
</script>

<style scoped>

</style>